import { FC, SVGProps } from 'react';
import { CookerIcon } from '../assets/icons/appliances/cooker';
import { DishwasherIcon } from '../assets/icons/appliances/dishwasher';
import { MiscApplianceIcon } from '../assets/icons/appliances/miscAppliance';
import { RefrigeratorIcon } from '../assets/icons/appliances/refrigerator';
import { SmallApplianceIcon } from '../assets/icons/appliances/smallAppliance';
import { SoundAndVisionIcon } from '../assets/icons/appliances/soundAndVision';
import { TelevisionIcon } from '../assets/icons/appliances/television';

export const iconPalette: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  cook: CookerIcon,
  dish: DishwasherIcon,
  rfrg: RefrigeratorIcon,
  misc: MiscApplianceIcon,
  sdas: SmallApplianceIcon,
  tele: TelevisionIcon,
  sovi: SoundAndVisionIcon,
};
